class IWishlist extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.updateWishlistCount()
  }

  setupListeners () {
    super.setupListeners()

    this.externalEls.trigger.elements.forEach(button => {
      button.addEventListener('click', e => {
        this.addHeader()
      })
    })

    if (this.els?.close?.exists) {
      this.els.close.elements.forEach(closeEl => {
        closeEl.addEventListener('click', this.onClose.bind(this))
      })
    }

    if (document.querySelector('.iWishAdd')) {
      document.querySelectorAll('.iWishAdd').forEach(addToWishlistEl => {
        addToWishlistEl.addEventListener('click', () => {
          window.setTimeout(() => {
            this.updateWishlistCount()
          }, 500)
        })
      })
    }

    this.listeners.add(document.body, 'wishlist:add', () => this.open())
  }

  open () {
    this.externalEls.trigger.element.click()
  }

  updateWishlistCount () {
    if (this.externalEls?.count?.exists && typeof Storage !== 'undefined') {
      this.externalEls.count.elements.forEach(countEl => {
        const count =
          typeof localStorage.iWishCnt !== 'undefined'
            ? localStorage.iWishCnt
            : ''
        countEl.dataset.count = count
        countEl.innerHTML = count
      })
    }
  }

  onClose () {
    if (document.querySelector('.iwish-backdrop')) {
      document.querySelector('.iwish-backdrop').click()
    }
  }

  replaceCartText () {
    if (document.querySelector('.cart-btn')) {
      document.querySelectorAll('.cart-btn').forEach(cartBtnEl => {
        cartBtnEl.textContent = cartBtnEl.textContent.replace('CART', 'Bag')
      })
    }
  }

  addHeader () {
    if (this?.els?.header?.exists) {
      const container = document.querySelector('.react-side-draw')
      container.insertBefore(this.els.header.element, container.firstChild)
    }
  }
}

if (!customElements.get('i-wishlist')) {
  customElements.define('i-wishlist', IWishlist)
}

class IWishlistButton extends window.BAO.CustomElement({
  SuperClass: HTMLButtonElement,
}) {
  static get observedAttributes () {
    return ['class']
  }

  attributeChangedCallback (name) {
    if (name !== 'class') return

    this.setAriaLabel(this)
  }

  isAdded (buttonEl) {
    return buttonEl?.matches(this.selector)
  }

  setAriaLabel (buttonEl) {
    const value = this.isAdded(buttonEl)
      ? window.theme?.strings?.removeFromWishlist
      : window.theme?.strings?.addToWishlist

    buttonEl.setAttribute('aria-label', value)
  }

  get selector () {
    return '.iwishAdded'
  }
}

if (!window.customElements.get('i-wishlist-button')) {
  window.customElements.define('i-wishlist-button', IWishlistButton, {
    extends: 'button',
  })
}
